import { Box, Typography } from '@mui/material';

const columns = (pumpRampUnits, hasNoCuttings, targetECDWithSBP, targetName) => [
  {
    field: 'steps',
    headerName: 'Steps',
    renderHeader: () => (
      <Box>
        <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
          Steps
        </Typography>
      </Box>
    ),
    headerAlign: 'center',
    align: 'center',
    width: 60,
  },
  {
    field: 'flow_in',
    headerName: `Flow In (${pumpRampUnits?.flow_in?.label})`,
    width: targetECDWithSBP ? 60 : 90,
    renderHeader: () => (
      <Box>
        <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
          Flow In
        </Typography>
        <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
          ({pumpRampUnits?.flow_in?.label})
        </Typography>
      </Box>
    ),
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return value.toFixed(pumpRampUnits?.flow_in?.decimals);
    },
  },
  {
    field: 'sbp',
    headerName: `SBP (${pumpRampUnits?.sbp?.label})`,
    width: targetECDWithSBP ? 60 : 100,
    renderHeader: () => (
      <Box>
        <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
          SBP
        </Typography>
        <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
          ({pumpRampUnits?.sbp?.label})
        </Typography>
      </Box>
    ),
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return value.toFixed(pumpRampUnits?.sbp?.decimals);
    },
  },
  {
    field: 'no_cuttings_sbp',
    headerName: `Clean-Mud SBP (${pumpRampUnits?.no_cuttings_sbp?.label})`,
    width: targetECDWithSBP ? 110 : 150,
    renderHeader: () => (
      <Box>
        <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
          Clean-Mud SBP
        </Typography>
        <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
          ({pumpRampUnits?.no_cuttings_sbp?.label})
        </Typography>
      </Box>
    ),
    hide: !hasNoCuttings,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return value.toFixed(pumpRampUnits?.no_cuttings_sbp?.decimals);
    },
  },
  {
    field: 'target_ecd_with_sbp',
    headerName: 'Target / ECD',
    width: 110,
    hide: !targetECDWithSBP,
    headerAlign: 'center',
    align: 'center',
    renderHeader: () => (
    <Box textAlign="center">
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
        {targetName.replace(/_/g, ' ').toUpperCase()}
      </Typography>
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
        ECD ({pumpRampUnits?.target_ecd_with_sbp?.label})
      </Typography>
    </Box>
    ),
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return value.toFixed(pumpRampUnits?.target_ecd_with_sbp?.decimals);
    },
  },
];
export default columns;
